import { useAtom } from 'jotai';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { createReportSuccessDialogAtom } from '../atoms';
import { useOnClickOutside } from '../hooks';
import { PATHS } from '../lib/paths';

export function CreateReportSuccessDialog() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [state, setState] = useAtom(createReportSuccessDialogAtom);
  const dialog = useRef<HTMLDialogElement | null>(null);

  const handleClose = () => {
    setState({ isOpen: false, report: undefined });
    dialog.current?.close();
  };

  const handleShareClick = () => {
    if (!state.report?.id) return;
    navigator.clipboard.writeText(
      `${import.meta.env.VITE_DOMAIN}${PATHS.reportPath(state.report.id)}`,
    );
    toast.success(t('common.copiedLink'));
  };

  useEffect(() => {
    if (!dialog.current?.open && state.isOpen) dialog.current?.showModal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.isOpen]);

  return (
    <dialog ref={dialog} className="max-w-xl">
      <h3 className="text-hero">{t('report.successDialog.subtitle')}</h3>
      <span className="whitespace-normal">{t('report.successDialog.description')}</span>
      <h3 className="text subtitle font-semibold">{t('report.successDialog.mainInfo')}</h3>
      <div className="grid grid-cols-[max-content_auto] grid-rows-3 items-center gap-x-8 gap-y-2">
        <span className="font-semibold">{t('report.name')}:</span>
        <span>{state.report?.name}</span>

        <span className="font-semibold">{t('report.link')}:</span>
        <div className="flex items-center">
          {state.report && (
            <Link
              className="whitespace-normal break-all grow"
              to={PATHS.reportPath(state.report.id)}
            >
              {`${import.meta.env.VITE_DOMAIN}${PATHS.reportPath(state.report.id)}`}
            </Link>
          )}
          <button onClick={handleShareClick}>
            <i className="ri-file-copy-line" />
          </button>
        </div>
      </div>
      <div className="flex justify-end gap-2">
        <button
          className="primary-outline"
          onClick={() => {
            handleClose();
            if (!state.report?.id) return;
            navigate(PATHS.reportPath(state.report.id));
          }}
        >
          {t('common.details')}
        </button>
        <button
          className="primary-fill"
          onClick={() => {
            handleClose();
            navigate(PATHS.homePath());
          }}
        >
          {t('common.fine')}
        </button>
      </div>
    </dialog>
  );
}
